import React from "react";
import { ProductTypes } from "../../../../../part-panel/lib/product-types";
import { toElementProps } from "../../Element";
import ProductTypeImage, { ProductTypeImageStyles } from "./ProductTypeImage.jsx";

export function BlockHeaderImageVerticalStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-header-image-vertical": {
            width: "500px",
            height: "30vh",
            maxHeight: "70vh",
            justifySelf: "center",

            "&.cross-platform, &.web-product": {
                width: "1200px",
            },

            [MobileBreakpoint]: {
                width: "100%",
                height: "auto",

                "&.cross-platform, &.web-product": {
                    width: "100%",
                },
            },
        },

        ...ProductTypeImageStyles(params),
    };
}

export default function BlockHeaderImageVertical(props) {
    const { ProductType } = props.variables;

    // !TODO Remove if unused (FullWidthBg, EventHeader already inside variables)
    const {
        variables: { FullWidthBg },
    } = ProductTypes.filter(type => type.value === ProductType)[0];

    if (FullWidthBg) {
        return null;
    }

    const elProps = toElementProps(props, { className: ["block-header-image-vertical", ProductType] });
    return (
        <div {...elProps}>
            <ProductTypeImage variables={props.variables} />
        </div>
    );
}
